export class Transporte {
  public id: string;
  public codTransp: string;
  public nombreTransp: string;
  public domicilio: string;
  public localidad: string;
  public codProvincia: string;
  public codPostal: string;
  public cuit: string;
  public codInscripcion: string;
  public fecCreacion: Date = new Date();
  public usrCreacion: string;
  public fecModif: Date | undefined;
  public usrModif: string | undefined;

  public estado: boolean;
  public isAdd: boolean;
  public isSave: boolean;
  public isEdit: boolean;
  public isActiveRelation: boolean;
  public originalData: Transporte;

  static transformTransporte(data: any): Transporte{
    let transporte = new Transporte;
    transporte.id = data.id;
    transporte.codTransp = data.codTransp;
    transporte.nombreTransp = data.nombreTransp;
    transporte.domicilio = data.domicilio;
    transporte.localidad = data.localidad;
    transporte.codProvincia = data.codProvincia;
    transporte.codPostal = data.codPostal;
    transporte.cuit = data.cuit;
    transporte.codInscripcion = data.codInscripcion;

    transporte.estado = data.estado;
    transporte.usrCreacion = data.usrCreacion;
    transporte.fecCreacion = new Date(data.fecCreacion);

    transporte.usrModif = data.usrModif;
    transporte.fecModif = data.fecModif ? new Date(data.fecModif) : undefined;

    return transporte;
  }
}
